/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Table, Schema, Button } from 'rsuite';
import { toast } from 'react-toastify';
import { Plus } from '@rsuite/icons';

import { Container } from '~/styles/tabela';

import api from '~/services/api';
import {
  CelulaEditavel,
  CelulaAcao,
} from '~/components/Celulas/components/CelulaEditavel';
import { ModalIcon } from '~/components/ModalCriacao/ModalIcon';
import { Modal2 } from '~/components/ModalCriacao/Modal2';
import { Modal1 } from '~/components/ModalCriacao/Modal1';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';
import SearchTable from '../components/SearchTable';
import Card from '../../../components/Card';
import PageHeader from '../../../components/PageHeader';

const { HeaderCell, Column } = Table;

const { StringType } = Schema.Types;

const modelo = Schema.Model({
  descricao: StringType().isRequired('Descrição Obrigatório'),
});

function Genero() {
  const [dados, setDados] = useState({
    idiomasLista: [],
    idiomasListaFiltrada: [],
    filtro: '',
    objeto: {},
  });
  const [apagarIdiomaDialog, setApagarIdiomaDialog] = useState({
    exibir: false,
    genero: {},
  });
  const [carregando, setCarregando] = useState(true);
  const [adicionarGeneroDialog, setAdicionarGeneroDialog] = useState(false);
  const [camposInput, setCamposInput] = useState({});

  async function buscarIdiomas() {
    const resposta = await api.get('genero');
    const resposta1 = await api.get('genero');
    setDados({
      idiomasLista: resposta.data,
      idiomasListaFiltrada: resposta.data,
      listaInicial: resposta1.data,
    });
    setCarregando(false);
  }

  useEffect(() => {
    buscarIdiomas();
  }, []);

  function filtrarLista(texto) {
    setDados({
      ...dados,
      idiomasListaFiltrada: dados.idiomasLista.filter((genero) =>
        genero.genero
          .toString()
          .toUpperCase()
          .includes(texto ? texto.toUpperCase() : '')
      ),
      filtro: texto,
    });
  }

  function abrirApagarDialog(genero) {
    setApagarIdiomaDialog({
      exibir: true,
      genero,
    });
  }

  function fecharApagarDialog() {
    setApagarIdiomaDialog({
      exibir: false,
      genero: {},
    });
  }

  async function excluirIdioma() {
    try {
      await api.delete(`/genero/${apagarIdiomaDialog.genero.id}`);
      toast.success('Plataforma excluida com sucesso');
      fecharApagarDialog();
      buscarIdiomas();
    } catch (e) {
      toast.error(e.message);
    }
  }

  async function adicionarIdioma() {
    try {
      setCarregando(true);
      await api.post(`/genero`, camposInput);
      toast.success('Genero adicionado com sucesso');
      setCarregando(false);
      setAdicionarGeneroDialog(false);
      buscarIdiomas();
    } catch (e) {
      toast.error(e.message);
    }
  }

  function alterarTextoCelula(id, key, value) {
    const nextData = Object.assign([], dados.idiomasLista);
    nextData.find((item) => item.id === id)[key] = value;
    setDados({ ...dados, idiomasLista: nextData });
    filtrarLista(dados.filtro);
  }

  async function alterarEstadoCelula(id) {
    const novaLista = Object.assign([], dados.idiomasLista);
    const item = novaLista.find((genero) => genero.id === id);
    const itemIncial = dados.listaInicial.find((genero) => genero.id === id);
    if (item.status === 'EDIT' && item.genero !== itemIncial.genero) {
      try {
        setCarregando(true);
        await api.put(`genero/${id}`, item);
        toast.success('Idioma atualizado com sucesso');
        buscarIdiomas();
      } catch (error) {
        toast.error(error.message);
      }
      setCarregando(false);
    } else {
      item.status = item.status ? null : 'EDIT';
      setDados({ ...dados, idiomasLista: novaLista });
      filtrarLista(dados.filtro);
    }
  }

  return (
    <Container>
      <PageHeader
        title="Gênero"
        subtitle="Gerencie os gêneros disponíveis no sistema."
        actions={
          <Button
            appearance="primary"
            startIcon={<Plus />}
            onClick={() => setAdicionarGeneroDialog(true)}
          >
            Novo Gênero
          </Button>
        }
      />

      <Card>
        <SearchTable estilo={{ width: '300px' }} filtrarLista={filtrarLista} />
        <TabelaSemPaginacao
          carregando={carregando}
          dados={dados.idiomasListaFiltrada}
        >
          <Column resizable width={200}>
            <HeaderCell>Ações</HeaderCell>
            <CelulaAcao
              dataKey="id"
              onClick={alterarEstadoCelula}
              onDelete={abrirApagarDialog}
            />
          </Column>
          <Column resizable width={240} sortable>
            <HeaderCell>Gênero</HeaderCell>
            <CelulaEditavel dataKey="genero" onChange={alterarTextoCelula} />
          </Column>

        </TabelaSemPaginacao>
      </Card>

      <Modal1
        show={adicionarGeneroDialog}
        onHide={() => setAdicionarGeneroDialog(false)}
        title="Adicionar genero"
        label="Genero"
        name="genero"
        model={modelo}
        onSubmit={() => adicionarIdioma()}
        onChange={setCamposInput}
        onClick={() => setAdicionarGeneroDialog(false)}
      />

      <Modal2
        show={apagarIdiomaDialog.exibir}
        onHide={fecharApagarDialog}
        title="Excluir genero"
        text="Você realmente deseja excluir este genero ?"
        apagarId={apagarIdiomaDialog.genero.id}
        apagarDado={apagarIdiomaDialog.genero.genero}
        fecharApagarDialog={fecharApagarDialog}
        excluir={() => excluirIdioma()}
      />
    </Container>
  );
}

export default Genero;
